module.exports = __webpack_public_path__ + "img/global.088d866.svg";